import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Checkbox } from '../../../common/checkbox';
import { NumberHelper } from '../../../helpers/NumberHelper';
import { SearchStore } from '../../../stores/SearchStore';
import styles from './Filters.css';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const generateFilterCallback = (filterType, value, checkType) => () => {
  SearchStore.toggleFilter(filterType, value, checkType);
};

const Filters = (props) => {
  if (!SearchStore.filtersValid) {
    return <div className={props.className} />;
  }
  return (
    <div className={[props.className, styles.container].join(' ')}>
      <div className={styles.internalContainer}>
        {
          SearchStore.filters[SearchStore.filterTypes.PRICE] &&
          SearchStore.filters[SearchStore.filterTypes.PRICE].length > 0 &&
          <div className={styles.filterContainer}>
            <h3 className={styles.filterTitle}>
              Precio
            </h3>
            <div className={styles.filterList}>
              {
                SearchStore.filters[SearchStore.filterTypes.PRICE].map(filter => (
                  <div
                    className={styles.filterLine}
                    key={filter.min}
                  >
                    <div className={styles.filterLeftContent}>
                      <Checkbox
                        checked={filter.enabled}
                        className={styles.checkbox}
                        onClick={generateFilterCallback(SearchStore.filterTypes.PRICE, filter.min)}
                      />
                      ${NumberHelper.localizeNumber(filter.min)}
                      &nbsp;a ${NumberHelper.localizeNumber(filter.max)}
                    </div>
                    <p className={styles.productCount}>
                      ({filter.count})
                    </p>
                  </div>
                ))
              }
            </div>
          </div>
        }
        {
          SearchStore.products.length > 0 &&
          <div className={styles.filterContainer}>
            <h3 className={styles.filterTitle}>
              Stock
            </h3>
            <div className={styles.filterList}>
              <div
                className={styles.filterLine}
              >
                <div className={styles.checkboxContainer}>
                  <Checkbox
                    checked={SearchStore.filters[SearchStore.filterTypes.STOCK].enabled}
                    className={styles.checkbox}
                    // The stock filter requires no value, it's a simple toggle
                    onClick={generateFilterCallback(SearchStore.filterTypes.STOCK, null)}
                  />
                  En stock
                </div>
                <p className={styles.productCount}>
                  ({SearchStore.filters[SearchStore.filterTypes.STOCK].count})
                </p>
              </div>
            </div>
          </div>
        }
        {
          SearchStore.filters[SearchStore.filterTypes.CATEGORY] &&
          SearchStore.filters[SearchStore.filterTypes.CATEGORY].length > 0 &&
          <div className={styles.filterContainer}>
            <h3 className={styles.filterTitle}>
              Categoría
            </h3>
            <div className={styles.filterList}>
              { // Show each category and it sub menues
                SearchStore.filters[SearchStore.filterTypes.CATEGORY].map(filter => (
                  <div
                    key={filter.id}
                  >
                    <div
                      className={styles.filterLine}
                    >
                      <div className={styles.filterLeftContent}>
                        <Checkbox
                          checked={filter.enabled}
                          className={styles.checkbox}
                          onClick={
                            generateFilterCallback(
                              SearchStore.filterTypes.CATEGORY,
                              filter.id,
                              SearchStore.checkTypes.SUB_MENU,
                              )
                          }
                        />
                        {filter.name}
                      </div>
                      <p className={styles.productCount}>
                        ({filter.count})
                      </p>
                    </div>
                    {
                      filter.productTypes.map(subMenu => (
                        <div
                          className={styles.filterChildLine}
                          key={subMenu.id}
                        >
                          <div className={styles.filterLeftContent}>
                            <div>
                              <span className={styles.filterChildArrow}>└</span>
                              <Checkbox
                                checked={subMenu.enabled}
                                className={styles.checkbox}
                                onClick={
                                  generateFilterCallback(
                                    SearchStore.filterTypes.CATEGORY,
                                    subMenu.id,
                                    SearchStore.checkTypes.PRODUCT_TYPE,
                                    )
                                }
                              />
                            </div>
                            {subMenu.name}
                          </div>
                          <p className={styles.productCount}>
                            ({subMenu.count})
                          </p>
                        </div>
                      ))
                    }
                  </div>
                ))
              }
            </div>
          </div>
        }
      </div>
    </div>
  );
};

Filters.propTypes = IPropTypes;
Filters.defaultProps = defaultProps;

const ObservedFilters = observer(Filters);

export { ObservedFilters as Filters };



// WEBPACK FOOTER //
// ./src/pages/search/filters/Filters.jsx